import React from 'react';
import { useNavigate } from 'react-router-dom';
import { QuizSettings } from '../types/quiz';
import {
  Container,
  Card,
  Title,
  FinalScore,
  ResultText,
  Button,
  GameOverContainer
} from '../styles/StyledComponents';

interface GameOverProps {
  score: number;
  totalQuestions: number;
  onRestart: () => void;
  settings: QuizSettings;
}

const GameOver: React.FC<GameOverProps> = ({ score, totalQuestions, onRestart, settings }) => {
  const navigate = useNavigate();
  
  const getResultMessage = () => {
    const percentage = (score / totalQuestions) * 100;
    
    if (percentage >= 90) {
      return "Outstanding! You're a quiz master!";
    } else if (percentage >= 70) {
      return "Great job! You really know your stuff!";
    } else if (percentage >= 50) {
      return "Good effort! Keep practicing!";
    } else if (percentage >= 30) {
      return "Not bad, but there's room for improvement.";
    } else {
      return "Better luck next time! Keep learning!";
    }
  };

  return (
    <Container>
      <Card>
        <GameOverContainer>
          <Title>Game Over!</Title>
          <FinalScore>
            {settings.mode === 'endless' ? (
              <>
                {score} {score === 1 ? 'Question' : 'Questions'} Answered Correctly
              </>
            ) : (
              <>
                {score} / {totalQuestions}
              </>
            )}
          </FinalScore>
          <ResultText>{getResultMessage()}</ResultText>
          <Button onClick={() => {
            onRestart();
            navigate('/');
          }}>
            New Game
          </Button>
        </GameOverContainer>
      </Card>
    </Container>
  );
};

export default GameOver;
